import { useQuery } from '@tanstack/react-query';
import { getModelByName, getModels } from '@/lib/actions/userModels';
import { useAuth } from '@/components/providers/AuthProvider';

export const useModels = () => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['user-models'],
    queryFn: getModels,
    enabled: !!user,
  });
};

export const useModelByName = (name: string) => {
  return useQuery({
    queryKey: ['model-by-name', name],
    queryFn: () => getModelByName(name),
    enabled: !!name,
  });
};
